// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1aXYW","buttons":"SendReceipts_buttons__tSmXG","email":"SendReceipts_email__HypOm","bookApptTitle":"SendReceipts_bookApptTitle__1s1h0"};